export default "__VITE_ASSET__BDWWcIPZ__"